// extracted by mini-css-extract-plugin
export default {"tos_page":"terms-of-service_tos_page__1pfQi","email_link":"terms-of-service_email_link__jCJGH","submit_container":"terms-of-service_submit_container__IsB-Y"};